module.exports = __webpack_public_path__ + "static/img/Ty-Gallop.85ffbfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ty-Gallop.jpg
// module id = Netk
// module chunks = 0